<template>
  <div class="card" v-loading.fullscreen.lock="loader">
    <div class="card-body">
      <div class="section-heading">SURVEY GROUPS</div>
      <br>
      <div class="collapse_group">
        <el-collapse v-model="activeNames" accordion v-for="(item, key) in surveyGroup" :key="key" @change="handleChange">
          <el-collapse-item :title="item.name" :name="key" class="SGroupList">
            <div class="SGcard">
              <survey-group-info-table :SurveyGroupData="surveyGroupInfo"></survey-group-info-table>
              <div class="row m-3 flex-end" style="margin-right:10rem;">
                <el-button style="width: 5rem;" class="btn-theme" @click="editSurveyGroup(key)">Edit</el-button>
                <el-button style="width: 5rem;" class="btn-theme" @click="deleteDialog(key)">Delete</el-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-dialog
        class="SubGroup-heading"
          title="Edit Survey Group"
          :visible.sync="dialog"
          align="middle"
          width="60%">
          <el-form ref="form" class="row" :model="form" :rules="rules" label-width="120px" label-position="top">
            <el-form-item class="col-md-6" label="Group Name" prop="surveyGroupName">
              <el-input v-model="form.surveyGroupName" placeholder="Enter Group Name"></el-input>
            </el-form-item>
            <el-form-item class="col-md-6" label="Surveys" prop="selectedSurveyList">
              <el-select v-model="form.selectedSurveyList" multiple collapse-tags  placeholder="Select Surveys">
                <el-option
                  v-for="(item, key) in surveys"
                  :key="key"
                  :label="item.en.title"
                  :value="key">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="row m-3 flex-end" style="margin-left:6rem;">
              <el-button class="btn-theme" @click="editSurvey('form')">Submit Survey</el-button>
            </div>
          </el-form>
        </el-dialog>
        <el-dialog
          title="Delete Survey Group"
          :visible.sync="dialogDel"
          width="30%">
          <span>You want to delete survey group</span>
          <span slot="footer" class="dialog-footer">
            <el-button class="btn-theme" @click="deleteSurveyGroup">Confirm</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import SurveyGroupInfoTable from './SurveyGroupInfoTable'
import { mapActions, mapGetters } from 'vuex'
import { eventbus } from '../../main'
export default {
  name: 'SurveyGroupList',
  components: {
    SurveyGroupInfoTable
  },
  data () {
    return {
      GroupId: '',
      DeleteGroupId: '',
      tableData: [],
      activeNames: '1',
      dialog: false,
      dialogDel: false,
      subListIndex: 0,
      key1: '',
      surveyGroup: [],
      surveyGroupInfo: [],
      surveys: [],
      loader: false,
      loaderDel: false,
      loaderAdd: false,
      form: {
        surveyGroupName: '',
        selectedSurveyList: []
      },
      rules: {
        surveyGroupName: [
          { required: true, message: 'Input Activity name', trigger: 'change' }
        ],
        selectedSurveyList: [
          { required: true, message: 'Select surveys for this group', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getSurveyGroup: 'Survey/getSurveyGroup',
      getSurveys: 'Survey/getSurveys'
    })
  },
  methods: {
    ...mapActions({
      fetchSurveyGroup: 'Survey/fetchSurveyGroup',
      fetchSurveys: 'Survey/fetchSurveys',
      deleteSurveyGroupById: 'Survey/deleteSurveyGroupById',
      updateSurveyGroupById: 'Survey/updateSurveyGroupById'
    }),
    handleChange (val) {
      if (val) {
        let groupInfo1 = []
        this.surveyGroup[val].surveys.forEach((ele, index) => {
          let groupInfo = [{
            id: '',
            title: '',
            startDate: '',
            endDate: '',
            surveyType: ''
          }]
          groupInfo.id = ele
          groupInfo.title = this.surveys[ele].en.title
          groupInfo.startDate = this.surveys[ele].surveyStartDate
          groupInfo.endDate = this.surveys[ele].surveyEndDate
          groupInfo.surveyType = this.surveys[ele].surveyType
          groupInfo1.push(groupInfo)
        })
        this.surveyGroupInfo = groupInfo1
      }
    },
    showInfo (value) {
      this.surveyGroupInfo = this.surveyGroup[value]
    },
    editSurveyGroup (value) {
      this.GroupId = value
      this.form.surveyGroupName = this.surveyGroup[value].name
      this.dialog = true
    },
    editSurvey (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.updateSurveyGroupById({
            id: this.GroupId,
            name: this.form.surveyGroupName,
            surveys: this.form.selectedSurveyList
          })
          this.$refs[form].resetFields()
          // this.$message.success('Survey Group Edited')
          this.dialog = false
          this.fetchSurveyGroup()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    deleteDialog (value) {
      this.dialogDel = true
      this.DeleteGroupId = value
    },
    deleteSurveyGroup () {
      this.deleteSurveyGroupById({
        id: this.DeleteGroupId
      })
      this.dialogDel = false
      this.DeleteGroupId = ''
      this.loader = true
      this.fetchSurveyGroup()
    }
  },
  watch: {
    getSurveyGroup (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveyGroup = value.data
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    surveyGroupInfo (value) {
      console.log('change', value)
    },
    getSurveys (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveys = value.data
      } else {
        this.$message.error(value.message)
      }
    }
  },
  mounted () {
    this.loader = true
    this.fetchSurveyGroup()
    this.fetchSurveys()
  },
  created () {
    eventbus.$on('SGadded', () => {
      this.fetchSurveyGroup()
    })
  }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SurveyGroup/SurveyGroupList.vue